@if (checkboxFilter()) {
  <div class="action-bar">
    <ng-container *transloco="let t">
      @if (checkboxFilter() === 'all') {
        <xt-ui-kit-checkbox
          [checked]="true"
          [dataCy]="dataCy + 'action-bar.checkbox.all'"
          (change)="selectAll($event)"
        >
          {{ t('app.labels.all') }}
        </xt-ui-kit-checkbox>
      }
      @if (checkboxFilter() !== 'all') {
        <xt-ui-kit-checkbox
          [indeterminate]="checkboxFilter()"
          [dataCy]="dataCy + 'action-bar.checkbox-filter.all'"
          (change)="deselectAll()"
        >
          {{ t('app.diary.chosen') }} ({{ getSelectedDocuments().length }})
        </xt-ui-kit-checkbox>
      }
      <xt-portal-actions
        [actionOptions]="actions"
        [actionBarActions]="actionBarActions"
        [dataCy]="dataCy + '.action-bar'"
        (actionHandler)="action($event)"
      />
    </ng-container>
  </div>
}
